import React, { useEffect, useState } from 'react';
import '../styles/contact.css'; 

const Contact = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const message = "Need Cricket ID";
  const encodedMessage = encodeURIComponent(message);
  const ContactLink = `https://wa.me/918977772819?text=${encodedMessage}`;
  const whatsappLink = `https://wa.me/918977772819?text=${encodedMessage}`;

  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    position: '',
    date: '',
    link: '',
  });

  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { firstName, lastName, email, phone, position, date, link } = formData;

    try {
      let formDataToSend = new FormData();
      formDataToSend.append('firstName', firstName);
      formDataToSend.append('lastName', lastName);
      formDataToSend.append('email', email);
      formDataToSend.append('phone', phone);
      formDataToSend.append('position', position);
      formDataToSend.append('date', date);
      formDataToSend.append('link', link);

      const response = await fetch(
        'https://script.google.com/macros/s/AKfycbwg4dB55XBJidlaO7kNhhELk1oT9SK6TOZJZdu5IVqMACaTINrwp3q4vVZIc8VajLFKcA/exec',
        {
          method: 'POST',
          body: formDataToSend,
        }
      );

      if (!response.ok) {
        throw new Error(`Error: ${response.statusText}`);
      }

      const message = await response.text();
      console.log('Response from Google Sheets:', message);
      setSuccess(true);

      setFormData({
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        position: '',
        date: '',
        link: '',
      });

      setTimeout(() => {
        setSuccess(false);
      }, 2000);
    } catch (error) {
      console.error(error.message);
      setError(error.message);
    }
  };

  return (
    <div className="contact-page">
      {/* Top Content Section */}
      <div className="contact-top">
        <h1><span className="highlight">Contact</span> Us</h1>
        <p>
          If you have any inquiries, feedback, or require assistance, our dedicated support team is here to help. 
          Your satisfaction is our priority, and we value your engagement with our platform.
        </p>
        <div className="contact-info">
          <p><strong>Contact Information:</strong><br />
          Customer Support Hotline: <a href={whatsappLink}>+91 7777857777</a></p>
        </div>
        <div className="support-details">
          <p>Our support team operates 24x7 to assist you promptly. Feel free to reach out to us for any of the following:</p>
          <ul>
            <li><strong>Account Assistance:</strong> Issues with your Reddy Anna account, password recovery, or verification.</li>
            <li><strong>Technical Support:</strong> For technical glitches or payment concerns.</li>
            <li><strong>General Inquiries:</strong> Questions about services, promotions, or terms.</li>
            <li><strong>Responsible Gaming Support:</strong> Guidance on responsible gaming practices.</li>
            <li><strong>Feedback:</strong> We welcome suggestions to improve our platform.</li>
          </ul>
          <p>
            Connect with us through the provided email or hotline, and our team will strive to address your queries 
            promptly and efficiently. Thank you for choosing Reddy Anna Book Official – where entertainment meets excellence!
          </p>
        </div>
      </div>

      {/* Bottom Form Section */}
      <div className="contact-bottom">
        <h2>Feel Free to Contact</h2>
        <form className="contact-form" onSubmit={handleSubmit}>
          <div className="input-group">
            <input
              type="text"
              name="firstName"
              placeholder="First Name"
              value={formData.firstName}
              onChange={handleChange}
              required
            />
            <input
              type="text"
              name="lastName"
              placeholder="Last Name"
              value={formData.lastName}
              onChange={handleChange}
              required
            />
          </div>
          <div className="input-group">
            <input
              type="email"
              name="email"
              placeholder="Email *"
              value={formData.email}
              onChange={handleChange}
              required
            />
            <input
              type="tel"
              name="phone"
              placeholder="Phone"
              value={formData.phone}
              onChange={handleChange}
            />
          </div>
          <div className="input-group">
            <input
              type="text"
              name="position"
              placeholder="Position"
              value={formData.position}
              onChange={handleChange}
            />
            <input
              type="date"
              name="date"
              value={formData.date}
              onChange={handleChange}
            />
          </div>
          <div className="input-group full-width">
            <input
              type="url"
              name="link"
              placeholder="Link to CV/LinkedIn"
              value={formData.link}
              onChange={handleChange}
            />
          </div>
          <button type="submit" className="apply-button">Apply</button>
        </form>
        {success && <p className="success-message">Form submitted successfully!</p>}
        {error && <p className="error-message">{error}</p>}
      </div>
      <div className="contactpage-buttons">
        <a href={whatsappLink} className="contactus-button" target="_blank" rel="noopener noreferrer">
          Open Your Demo Account
        </a>
        <a href={ContactLink} className="contactus-button" target="_blank" rel="noopener noreferrer">
          Contact Us Now
        </a>
      </div>
    </div>
  );
};

export default Contact;
